/** Parse LMS_META cells from a stored Marimo .py source (same shape as student cells). */

export type NotebookPreviewTest = {
  Value?: string[];
  Output?: string;
  title?: string;
  description?: string;
  errorMessage?: string;
  type?: string;
  keywords?: string[];
};

export type NotebookPreviewCell = {
  id: string;
  type: "code" | "markdown";
  source: string;
  read_only?: boolean;
  functionCall?: string;
  tests?: NotebookPreviewTest[];
};

export function cellsFromNotebookSource(source: string): NotebookPreviewCell[] {
  const text = String(source || "");
  const metaLine = text.split(/\r?\n/).find((line) => line.startsWith("# LMS_META="));
  if (!metaLine) {
    return [];
  }
  try {
    const meta = JSON.parse(metaLine.slice("# LMS_META=".length)) as {
      testsByCell?: Record<string, NotebookPreviewTest[]>;
      cells?: Array<{
        id?: string;
        type?: string;
        source?: string;
        readOnly?: boolean;
        read_only?: boolean;
        functionCall?: string;
        tests?: NotebookPreviewTest[];
      }>;
    };
    if (!Array.isArray(meta?.cells)) {
      return [];
    }
    const testsByCell = meta.testsByCell || {};
    return meta.cells.map((cell, index) => {
      const id = String(cell?.id || `cell-${index + 1}`);
      const type = cell?.type === "markdown" ? "markdown" : "code";
      const tests = Array.isArray(cell?.tests) && cell.tests.length
        ? cell.tests
        : testsByCell[id] || [];
      return {
        id,
        type,
        source: String(cell?.source || ""),
        read_only: Boolean(cell?.readOnly || cell?.read_only),
        functionCall: String(cell?.functionCall || ""),
        tests,
      };
    });
  } catch {
    return [];
  }
}
